import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CatalogueModal from "@/components/ui-shared/CatalogueModal";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetailPage from "@/pages/ProductDetailPage";
import Solutions from "@/pages/Solutions";
import SolutionDetailPage from "@/pages/SolutionDetailPage";
import LearningTracks from "@/pages/LearningTracks";
import Partners from "@/pages/Partners";
import PartnerDetailPage from "@/pages/PartnerDetailPage";
import CourseDetailPage from "@/pages/CourseDetailPage";
import About from "@/pages/About";
import Admin from "@/pages/Admin";

import "@/App.css";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
};

const Layout = ({ children, openCatalogue }) => (
    <div className="App relative">
        <Header onOpenCatalogue={openCatalogue} />
        <main className="relative">{children}</main>
        <Footer />
    </div>
);

const AppInner = () => {
    const [catalogueOpen, setCatalogueOpen] = useState(false);
    const openCatalogue = () => setCatalogueOpen(true);
    const closeCatalogue = () => setCatalogueOpen(false);

    useEffect(() => {
        window.__openCatalogue = openCatalogue;
        return () => { delete window.__openCatalogue; };
    }, []);

    const withLayout = (Comp, extraProps = {}) => (
        <Layout openCatalogue={openCatalogue}>
            <Comp {...extraProps} openCatalogue={openCatalogue} />
        </Layout>
    );

    return (
        <>
            <ScrollToTop />
            <Toaster richColors position="top-right" theme="dark" />
            <CatalogueModal open={catalogueOpen} onClose={closeCatalogue} />
            <Routes>
                <Route path="/" element={withLayout(Home)} />
                <Route path="/products" element={withLayout(Products)} />
                <Route path="/products/:slug" element={withLayout(ProductDetailPage)} />
                <Route path="/solutions" element={withLayout(Solutions)} />
                <Route path="/solutions/:slug" element={withLayout(SolutionDetailPage)} />
                <Route path="/learning-tracks" element={withLayout(LearningTracks)} />
                <Route path="/partners" element={withLayout(Partners)} />
                <Route path="/partners/:slug" element={withLayout(PartnerDetailPage)} />
                <Route path="/partners/:slug/courses/:courseId" element={withLayout(CourseDetailPage)} />
                <Route path="/about" element={withLayout(About)} />
                <Route path="/admin" element={withLayout(Admin)} />
            </Routes>
        </>
    );
};

function App() {
    return (
        <BrowserRouter>
            <AppInner />
        </BrowserRouter>
    );
}

export default App;
